/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type PensionSavingDetailPensionSavingStrategy =
  (typeof PensionSavingDetailPensionSavingStrategy)[keyof typeof PensionSavingDetailPensionSavingStrategy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PensionSavingDetailPensionSavingStrategy = {
  conservative: "conservative",
  balanced: "balanced",
  dynamic: "dynamic",
} as const;
